import { __assign } from "tslib";
import React from 'react';
import PnmacParagraph from '../Typography/PnmacParagraph';
import Tooltip from '@material-ui/core/Tooltip';
import { View } from 'react-native';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import { textStyle } from '../v2/theme';
var PnmacToolTip = function (_a) {
  var style = _a.style,
    title = _a.title,
    text = _a.text,
    size = _a.size,
    swap = _a.swap,
    containerStyle = _a.containerStyle;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement(PnmacParagraph, {
      style: {
        color: "#FFF"
      }
    }, title)
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },
    className: "tool-tip"
  }, /*#__PURE__*/React.createElement(View, {
    style: [{
      order: swap ? 2 : 0
    }, containerStyle]
  }, /*#__PURE__*/React.createElement(PnmacParagraph, {
    style: __assign(__assign(__assign({}, textStyle.defaultTextDescription), style), {
      fontSize: size
    })
  }, text)), /*#__PURE__*/React.createElement(View, {
    style: {
      marginLeft: swap ? 0 : 3,
      marginRight: swap ? 3 : 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      order: swap ? 0 : 2
    }
  }, /*#__PURE__*/React.createElement(InfoOutlined, {
    color: "primary",
    fontSize: "small"
  }))));
};
export default PnmacToolTip;